export default class EngineFileCard {
  constructor({ title, icon, type, fileName, additionalInformation }) {
    this.title = title;
    this.icon = icon;
    this.type = type;
    this.fileName = fileName;
    this.additionalInformation = additionalInformation;
  }
}
